import React from 'react';
import { InventoryIcon } from '../../Assets/Settings/SettingsIcon';
import FormLayout from '../../Components/Layout/FormLayout';
import AccountForm from './AccountForm';
import { t } from 'i18next';

const CreateAccount = ({ handleToast, history }) => (
    <FormLayout
        title={t('Settings.inventory_account')}
        Icon={InventoryIcon}
        subtitle={t('Contacts.add_new')}
        closeUrl="/settings"
    >
        <AccountForm history={history} handleToast={handleToast} />
    </FormLayout>
);

export default CreateAccount;
